/**
 * STOOPID sales attribution
 * Persist ?ref=CODE into Shopify cart attributes so it reaches the order webhook.
 */
(function () {
  const params = new URLSearchParams(window.location.search);
  const referralCode = (params.get('ref') || '').trim().toUpperCase();

  if (!referralCode) return;

  fetch('/cart/update.js', {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
      'Accept': 'application/json'
    },
    body: JSON.stringify({
      attributes: {
        sales_referral_code: referralCode
      }
    })
  }).catch((error) => {
    console.warn('Failed to persist referral code:', error);
  });
})();

// icon text slider 
$(document).ready(function () {

    $('.icon-text-slick').slick({
        speed: 5000,
        autoplay: true,
        autoplaySpeed: 0,
        centerMode: true,
        cssEase: 'linear',
        slidesToShow: 1,
        slidesToScroll: 1,
        variableWidth: true,
        infinite: true,
        initialSlide: 1,
        arrows: false,
        buttons: false
    });



    $('.video--slides').slick({
        slidesToShow: 3.5,
        slidesToScroll: 1,
        arrows: true,
        prevArrow: '.prev-btn',
        nextArrow: '.next-btn',
        dots: false,
        responsive: [
            {
                breakpoint: 991,
                settings: {
                    slidesToShow: 2.5
                }
            },
            {
                breakpoint: 768,
                settings: {
                    slidesToShow: 2
                }
            },
            {
                breakpoint: 430,
                settings: {
                    slidesToShow: 1
                }
            }
        ]
    });
    $('.testimonial-slider').slick({
        slidesToShow: 3,
        slidesToScroll: 1,
        dots: true,
        arrows: false,
        autoplay: true,
        autoplaySpeed: 3000,
        responsive: [
            {
                breakpoint: 992,
                settings: { slidesToShow: 2 }
            },
            {
                breakpoint: 768,
                settings: { slidesToShow: 1 }
            }
        ]
    });

});
//video slider homepage



document.addEventListener('DOMContentLoaded', function () {
    setTimeout(function () {
        if (window.jQuery && $('.relentless-slider').length && typeof $('.relentless-slider').slick === 'function') {
            $('.relentless-slider')
                .not('.slick-initialized')
                .slick({
                    slidesToShow: 4,
                    slidesToScroll: 1,
                    infinite: true,
                    responsive: [
                        { breakpoint: 900, settings: { slidesToShow: 2 } },
                        { breakpoint: 600, settings: { slidesToShow: 1 } },
                    ],
                });
        }
    }, 500);
});



$(document).ready(function () {
    function initRelatedProductsSlider() {
        const $slider = $('.related-products-slider .related-products__list');
        if ($slider.length && !$slider.hasClass('slick-initialized')) {
            $slider.slick({
                slidesToShow: 3,
                slidesToScroll: 1,
                infinite: false,
                arrows: true,
                dots: false,
                responsive: [
                    {
                        breakpoint: 1024,
                        settings: { slidesToShow: 3 }
                    },
                    {
                        breakpoint: 768,
                        settings: { slidesToShow: 2 }
                    },
                    {
                        breakpoint: 480,
                        settings: { slidesToShow: 1 }
                    }
                ]
            });
        }
    }

    // Initialize on load
    initRelatedProductsSlider();

    // Reinitialize when product recommendations load dynamically
    document.addEventListener('shopify:section:load', initRelatedProductsSlider);
    document.addEventListener('shopify:section:reorder', initRelatedProductsSlider);
});



document.addEventListener('DOMContentLoaded', () => {
    const component = document.querySelector('product-recommendations');

    if (!component) return;

    function findSlider() {
        if (component.shadowRoot) {
            return component.shadowRoot.querySelector('.related-products-slider');
        }
        return component.querySelector('.related-products-slider');
    }

    function initSlider() {
        const slider = findSlider();
        if (!slider) return;

        const slides = slider.querySelectorAll('.related-products-slider > *');

        if (slides.length < 4) {
            console.log('Less than 4 slides, slider disabled.');
            return;
        }

        if (!slider.classList.contains('slick-initialized')) {
            $(slider).slick({
                slidesToShow: 3,
                slidesToScroll: 1,
                arrows: false,
                dots: false,
                infinite: false,
                responsive: [
                    { breakpoint: 1024, settings: { slidesToShow: 2 } },
                    { breakpoint: 768, settings: { slidesToShow: 1 } },
                ],
            });
            console.log('Slider initialized.');
        }
    }

    /* -------------------------------
     * METHOD 1: Intercept Shopify request
     * ------------------------------- */
    const originalFetch = window.fetch;
    window.fetch = async (...args) => {
        const response = await originalFetch(...args);

        try {
            // Detect if this fetch is for product recommendations
            if (args[0].includes('product_recommendations')) {
                // Delay a bit and then initialize
                response
                    .clone()
                    .text()
                    .then(() => {
                        setTimeout(initSlider, 120);
                    });
            }
        } catch (e) { }

        return response;
    };

    /* --------------------------------
     * METHOD 2: Handle cached load (reload case)
     * -------------------------------- */
    setTimeout(() => {
        initSlider();
    }, 400);
});




$(document).ready(function () {
    var selected_id = $('.product-variant-id').val();
    $('.dynamic-nutrition-facts').each(function () {
        var variant_id = $(this).data('variant-id'); // correct syntax
        if (variant_id == selected_id) {
            var sugar_val = $(this).attr('sugar-value');
            $('.icon-with-text .icon-with-text__item').first().find('.h4 p strong').text(sugar_val);
        }
    });
    $(document).on('change', '.product-form__input input[type="radio"]', function () {

        setTimeout(function () {

            // Hide all sections
            $('.dynamic-nutrition-facts').removeClass('shown');

            // Get selected variant ID
            var selected_id = $('.product-variant-id').val();

            // Loop all nutrition sections
            $('.dynamic-nutrition-facts').each(function () {

                var variant_id = $(this).data('variant-id'); // correct syntax

                if (variant_id == selected_id) {
                    var sugar_val = $(this).attr('sugar-value');

                    $(this).addClass('shown'); // show this section
                    $('.icon-with-text .icon-with-text__item').first().find('.h4 p strong').text(sugar_val);
                }

            });

        }, 1000); // delay for Shopify to update variant ID
    });

});



// feature-logo-slider
$(document).ready(function () {
    $('.featured-logos__slider').slick({
        slidesToShow: 5,
        slidesToScroll: 1,
        autoplay: true,
        autoplaySpeed: 0,
        speed: 6000,
        cssEase: 'linear',
        infinite: true,
        arrows: false,
        dots: false,
        pauseOnHover: false,
        pauseOnFocus: false,
        responsive: [
            {
                breakpoint: 1500,
                settings: { slidesToShow: 4 }
            },
            {
                breakpoint: 1024,
                settings: { slidesToShow: 3 }
            },
            {
                breakpoint: 768,
                settings: { slidesToShow: 2 }
            }, {
                breakpoint: 576,
                settings: { slidesToShow: 1 }
            }
        ]
    });
});


// (vip offer)-Landing Page slider 

// document.addEventListener("DOMContentLoaded", function () {

//   $('.vip-scroll').slick({
//      slidesToShow: 1.5,
//   slidesToScroll: 1,
//   vertical: true,          
//   verticalSwiping: true,  
//   arrows: false,
//   dots: false,
//   infinite: false,
//   speed: 600,
//   adaptiveHeight: true

//   });

//   let isScrolling = false;

//   $('.vip-scroll').on('wheel', function (e) {
//     e.preventDefault();

//     if (isScrolling) return;
//     isScrolling = true;

//     if (e.originalEvent.deltaY > 0) {
//       $(this).slick('slickNext');
//     } else {
//       $(this).slick('slickPrev');
//     }

//     setTimeout(function () {
//       isScrolling = false;
//     }, 700);
//   });

// });


document.addEventListener("DOMContentLoaded", function () {

    const $slider = $('.vip-scroll');

    $slider.slick({
        slidesToShow: 1.5,
        slidesToScroll: 1,
        vertical: true,
        verticalSwiping: true,
        arrows: false,
        dots: false,
        infinite: false,
        speed: 600,
        adaptiveHeight: true,
        responsive: [
            {
                breakpoint: 1024,
                settings: {
                    slidesToShow: 1.2,
                    vertical: true,
                    verticalSwiping: true
                }
            },
            {
                breakpoint: 768,
                settings: {
                    slidesToShow: 1,
                    vertical: false,
                    verticalSwiping: false,
                    dots: true,
                    swipe: true
                }
            }
        ]
    });

    let isScrolling = false;

    $slider.on('wheel', function (e) {
        const delta = e.originalEvent.deltaY;
        const slick = $slider.slick('getSlick');
        const currentSlide = slick.currentSlide;
        const lastSlide = slick.slideCount - 1;

        /* ⬇️ LAST SLIDE → page scroll allow */
        if (delta > 0 && currentSlide === lastSlide) {
            return; // page scroll chale
        }

        /* ⬆️ FIRST SLIDE → page scroll allow */
        if (delta < 0 && currentSlide === 0) {
            return;
        }

        e.preventDefault();

        if (isScrolling) return;
        isScrolling = true;

        if (delta > 0) {
            $slider.slick('slickNext');
        } else {
            $slider.slick('slickPrev');
        }

        setTimeout(() => {
            isScrolling = false;
        }, 700);
    });

});


// Subscribe button select on product page 

document.addEventListener('DOMContentLoaded', function () {
    function initSubscription() {
        const subscribeBtn = document.querySelector('.subscription-btn');
        const atcBtn = document.querySelector('button[name="add"]');

        if (!subscribeBtn || !atcBtn) return;

        if (subscribeBtn.dataset.listenerAttached) return;
        subscribeBtn.dataset.listenerAttached = 'true';

        subscribeBtn.addEventListener('click', function (e) {
            e.preventDefault();

            const options = document.querySelectorAll('.subify-minimal-option');

            if (!options.length) {
                console.error('Subi options not found');
                return;
            }

            let subscribeOption = null;

            options.forEach((option) => {
                const text = option.innerText.toLowerCase();
                if (text.includes('subscribe')) {
                    subscribeOption = option;
                }
            });

            if (!subscribeOption) {
                console.error('Subscribe option not found');
                return;
            }

            subscribeOption.click();

            setTimeout(() => {
                atcBtn.click();
            }, 300);
        });
    }

    initSubscription();

    document.addEventListener('shopify:section:load', initSubscription);

    const observer = new MutationObserver(() => {
        initSubscription();
    });

    observer.observe(document.body, { childList: true, subtree: true });
});

document.querySelector('.fd-price-btn').addEventListener('click', function (e) {
    e.preventDefault();
    window._klOnsite = window._klOnsite || [];
    window._klOnsite.push(['openForm', 'UAeneW']);
});






